import { Controller } from "@hotwired/stimulus"
import { sendAnalyticsEvent } from "../../lib/analytics_beacon"

// Rides on the Share menu's Copy link item (TMS-840): the copy is the share
// controller's job, counting it is this one's. Email and SMS shares are counted by
// the server as they are sent.
export default class extends Controller {
  static values = { subjectType: String, subjectId: String, url: String }

  send() {
    if (!this.subjectTypeValue || !this.subjectIdValue) return

    sendAnalyticsEvent("content_shared", {
      subjectType: this.subjectTypeValue,
      subjectId: this.subjectIdValue,
      properties: { shared_link_id: this.urlValue, content_type: this.subjectTypeValue, channel: "copy_link" }
    })
  }
}
